/* =========================================================
   AKKURANDO – Anlass-Modul (Präfix akan), Handbuch Kap. 6 „Erlebnis-Dach“ / „Anlass-Modul“
   Wird nur an Anlass-Tagen geladen (oder in der Vorschau-Vorlage templates/index.akk-anlass.json).
   1. Datumsprüfung im Browser (Europe/Berlin): Eine veraltete Seite aus dem Cache räumt den Anlass nach seinem Ende weg.
   2. Vorschau: ?ake_datum=JJJJ-MM-TT wählt den Anlass nach denselben Regeln wie snippets/akk-erlebnis-heute.liquid.
   3. Dialog „Warum heute?“ | Interaktion: öffnen, schließen, Ansicht wechseln, Fokus (natives <dialog>).
   4. Interaktion erst beim ersten Öffnen bzw. Zeigen nachladen (data-akan-js, optional data-akan-css). Schnittstelle: window.AKAN.registriere(name, start).
   5. Messereignisse nach GA4-Schema über Shopify.analytics.publish (ein Custom Pixel leitet sie weiter), Protokoll in window.AKE_LOG.
   ========================================================= */
(() => {
  'use strict';
  const hero = document.querySelector('[data-akh-hero]');
  if (!hero || hero.dataset.akan) return;
  hero.dataset.akan = '1';
  const de = document.documentElement;
  const AKAN = window.AKAN = window.AKAN || { _reg: {}, _warte: {}, registriere(name, start) { this._reg[name] = start; if (this._warte[name]) this._warte[name](start); } };

  /* ---------- Datumsdienst (Browser) ---------- */
  const q = /[?&]ak[ex]_datum=(\d{4}-\d{2}-\d{2})/.exec(location.search);
  const berlin = () => { try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); } };
  const heute = q ? q[1] : berlin();
  const zahl = (d) => +String(d).replace(/-/g, '');
  const vorlagen = [...document.querySelectorAll('template[data-akan-vorschau]')];
  const vorschau = !!document.getElementById('ake-kalender');
  const ruhig = () => { let p = null; try { p = localStorage.getItem('akk-motion'); } catch (e) {} return p ? p === 'off' : matchMedia('(prefers-reduced-motion: reduce)').matches; };

  // gleiche Regeln wie Liquid: Saison (außer „aus“) verdrängt Anlässe, erste passende Zeile gewinnt; Vorschau zeigt auch Status „vorschau“
  function waehle(text, tag) {
    let saison = false, treffer = null;
    text.split('\n').forEach((z) => {
      z = z.trim();
      if (!z || z[0] === '#') return;
      const f = z.split('|');
      if (f.length < 5 || tag < zahl(f[2]) || tag > zahl(f[3])) return;
      if (f[0] === 'saison' && f[4] !== 'aus') saison = true;
      if (!treffer && f[0] === 'anlass' && (f[4] === 'freigegeben' || f[4] === 'vorschau')) treffer = f[1];
    });
    return saison ? null : treffer;
  }

  if (vorschau) {
    const id = waehle(document.getElementById('ake-kalender').textContent, zahl(heute));
    const tpl = id && vorlagen.find((t) => t.dataset.akanVorschau.split('|')[0] === id);
    if (!tpl && document.querySelector('template[data-aks-doodle="' + heute + '"]')) return; // Saisontag: Hinweis und Doodle setzt assets/akk-saison.js
    const hinweis = document.createElement('p');
    hinweis.className = 'akan-vorschau';
    hinweis.textContent = 'Vorschau ' + heute + ': ' + (tpl ? 'Anlass ' + id : 'kein Anlass, Startseite wie immer');
    document.body.append(hinweis);
    if (!tpl) return;
    const put = (ziel, wo, wie) => {
      const w = tpl.content.querySelector('[data-akan-ziel="' + ziel + '"]');
      if (w && wo) wo[wie](...[...w.childNodes].map((n) => document.importNode(n, true)));
    };
    const media = hero.querySelector('.akh-hero__media');
    put('text', hero.querySelector('.akh-hero__text'), 'prepend');
    put('bild', media, 'prepend');
    put('zeile', media, 'append');
    put('dialog', hero, 'append');
    hero.classList.add('akan-on');
  } else {
    // Seiten-Cache: Ist der Anlass laut Browser-Datum schon vorbei (oder noch nicht da), alles entfernen
    const t = hero.querySelector('[data-akan-von]');
    if (!t) return;
    const tag = zahl(heute);
    if (tag < zahl(t.dataset.akanVon) || tag > zahl(t.dataset.akanBis)) {
      hero.querySelectorAll('[data-akan-teil]').forEach((n) => n.remove());
      hero.classList.remove('akan-on', 'akan-intro');
      return;
    }
  }

  const dlg = hero.querySelector('dialog[data-akan-teil="dialog"]');
  if (!dlg) return;
  const id = dlg.dataset.akan;

  /* ---------- Messereignisse (Handbuch: GA4-Namensschema) ---------- */
  const track = (name, p) => {
    const d = Object.assign({ erlebnis_id: id, erlebnis_art: 'anlass' }, p || {});
    (window.AKE_LOG = window.AKE_LOG || []).push([name, d]);
    if (vorschau) return;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); } catch (e) { /* Messung darf nie stören */ }
  };
  const kopf = hero.querySelector('.akan-cap .akan-k') || hero.querySelector('.akan-m .akan-k');
  track('view_promotion', { promotion_id: 'anlass-' + id, promotion_name: kopf ? kopf.textContent.trim() : id, creative_slot: 'hero' });

  /* ---------- Dialog ---------- */
  // Ohne Skript öffnen Browser mit „Invoker Commands“ den Dialog selbst; mit Skript übernimmt dieses (Ansicht, Messung, Animation)
  document.querySelectorAll('[commandfor="akan-dlg"]').forEach((b) => { b.removeAttribute('command'); b.removeAttribute('commandfor'); });
  const segs = dlg.querySelectorAll('.akan-seg [data-akan-ansicht]');
  const slot = dlg.querySelector('[data-akan-slot]');
  const fokusZiel = (v) => (v === 'mitmachen' && dlg.querySelector('[data-akan-fokus]:not([hidden])')) || dlg.querySelector('#akan-h');
  function ansicht(v) {
    if (!slot) v = 'geschichte';
    dlg.dataset.ansicht = v;
    segs.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.akanAnsicht === v)));
  }
  function auf(v, quelle) {
    ansicht(v);
    if (!dlg.open) {
      dlg.showModal();
      de.classList.add('akan-lock');
      track('akan_dialog_auf', { ansicht: v, quelle: quelle || 'dialog' });
    }
    dlg.querySelectorAll('.akan-story,.akan-play').forEach((p) => { p.scrollTop = 0; });
    requestAnimationFrame(() => { const z = fokusZiel(v); if (z) z.focus({ preventScroll: true }); });
    dlg.dispatchEvent(new CustomEvent('akan:auf', { detail: { ansicht: v } }));
    lade().then(() => {
      if (dlg.open && dlg.dataset.ansicht === 'mitmachen' && v === 'mitmachen') { const z = fokusZiel(v); if (z && document.activeElement !== z) z.focus({ preventScroll: true }); }
      dlg.dispatchEvent(new CustomEvent('akan:auf', { detail: { ansicht: v } }));
    });
  }
  function zu() {
    if (!dlg.open) return;
    if (ruhig()) { dlg.close(); return; }
    dlg.classList.add('is-closing');
    setTimeout(() => { dlg.classList.remove('is-closing'); dlg.close(); }, 170);
  }
  dlg.addEventListener('close', () => de.classList.remove('akan-lock'));
  dlg.addEventListener('cancel', (e) => { e.preventDefault(); zu(); });
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) return zu();
    const b = e.target.closest('[data-akan-ansicht]');
    if (b) { auf(b.dataset.akanAnsicht, 'umschalter'); return; }
    const a = e.target.closest('a');
    if (a && a.hasAttribute('data-akan-produkt')) track('akan_produkt_klick', { ziel: a.dataset.akanProdukt });
    else if (a && a.hasAttribute('data-akan-quelle')) track('akan_quelle_klick', { link_url: a.href });
    else if (a && a.hasAttribute('data-akan-weiter')) track('akan_weiter_klick', { link_url: a.href });
  });
  const x = dlg.querySelector('[data-akan-zu]');
  if (x) x.addEventListener('click', zu);
  hero.addEventListener('click', (e) => {
    const b = e.target.closest('[data-akan-auf]');
    if (!b || dlg.contains(b)) return;
    const teil = b.closest('[data-akan-teil]');
    track('select_promotion', { promotion_id: 'anlass-' + id, creative_slot: 'hero-' + (teil ? teil.dataset.akanTeil : 'hero'), ziel: b.dataset.akanAuf });
    auf(b.dataset.akanAuf, teil ? teil.dataset.akanTeil : 'hero');
  });
  // Interaktion schon beim Zeigen auf einen Auslöser vorladen (schnelleres Öffnen); sonst erst beim Öffnen
  hero.addEventListener('pointerover', (e) => { if (e.target.closest('[data-akan-auf]')) lade(); }, { passive: true });
  hero.addEventListener('focusin', (e) => { if (e.target.closest('[data-akan-auf]')) lade(); });
  if (dlg.open) { de.classList.add('akan-lock'); lade(); } // per Invoker geöffnet, bevor das Skript da war

  /* ---------- Interaktion nachladen ---------- */
  let laden = null;
  function lade() {
    if (!slot || !dlg.dataset.akanJs) return Promise.resolve();
    if (laden) return laden;
    laden = new Promise((fertig) => {
      const name = slot.dataset.akanSlot;
      const start = (fn) => {
        let daten = {};
        try { daten = JSON.parse((dlg.querySelector('[data-akan-daten]') || {}).textContent || '{}'); } catch (e) { /* leere Daten */ }
        slot.textContent = '';
        try {
          fn(slot, { daten, dialog: dlg, ruhig, klein: () => matchMedia('(max-width: 899px), (max-height: 779px)').matches, track: (n, p) => track('akan_' + n, p) });
        } catch (e) {
          slot.innerHTML = '<p class="akan-play__wait">Das Experiment konnte nicht starten. Bitte lade die Seite neu.</p>';
          if (window.console) console.error('[akan]', e);
        }
        fertig();
      };
      // CSS der Interaktion (data-akan-css) parallel zum Skript laden; Start erst, wenn beides da ist (kein Aufblitzen ohne Stil)
      const css = dlg.dataset.akanCss ? new Promise((ok) => { const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = dlg.dataset.akanCss; l.onload = l.onerror = ok; document.head.append(l); }) : Promise.resolve();
      if (AKAN._reg[name]) { css.then(() => start(AKAN._reg[name])); return; }
      AKAN._warte[name] = (fn) => css.then(() => start(fn));
      const s = document.createElement('script');
      s.src = dlg.dataset.akanJs;
      s.async = true;
      s.onerror = () => { slot.innerHTML = '<p class="akan-play__wait">Das Experiment ließ sich nicht laden. Bitte lade die Seite neu.</p>'; fertig(); };
      document.head.append(s);
    });
    return laden;
  }
  AKAN.auf = auf;
  AKAN.zu = zu;
})();
